import * as moment from "moment";
import * as ko from "knockout";
import * as _ from "lodash";
import * as $ from "jquery";
import { Signal, system } from "portalframework";
import * as Split from "split.js";

ko.bindingHandlers.datepicker = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var dt = valueAccessor();
    var futureOnly = allBindings().futureOnly;
    (<any>$(element)).datepicker({
      language: moment.locale(),
      showOnFocus: true,
      autoclose: true,
      clearBtn: true,
      startDate: futureOnly ? new Date() : null,
      format: {
        toDisplay: (date, format, language) => {
          var d = new Date(date);
          if (date) {
            dt(d);
            return moment(date).format("yyyy-MM-DD");
          }
        },
        toValue: (date, format, language) => {
          if (typeof date === "function") {
            var d = date();
            if (date) {
              return d();
            }
          } else if (typeof date === "string") {
            return new Date(date);
          }

          return null;
        },
      },
    });
    (<any>$(element)).datepicker("setDate", valueAccessor);
    (<any>$(element)).datepicker().on("clearDate", () => {
      dt(null);
    });

    $(element).find("input").css("cursor", "pointer");
    $(element).find("input").css("background-color", "#fff");
  },

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {},
};

ko.bindingHandlers.dateTimePicker = {
  init: function (element, valueAccessor, allBindingsAccessor) {
    var options = $.extend(
      {
        showClear: true,
        allowInputToggle: true,
        focusOnShow: true,
        parseInputDate: function (date) {
          var d = new Date(date);
          if (date) {
            return moment(date);
          }
        },
      },
      allBindingsAccessor().dateTimePickerOptions || {},
    );

    (<any>$(element)).datetimepicker(options);

    ko.utils.registerEventHandler(element, "dp.change", function (event) {
      var value = valueAccessor();
      if (ko.isObservable(value)) {
        if (event.date === false) {
          value(null);
        } else {
          value(event.date);
        }
      }
    });

    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      var picker = $(element).data("DateTimePicker");
      if (picker) {
        picker.destroy();
      }
    });
    $(element).find("input").css("cursor", "pointer");
  },
  update: function (element, valueAccessor) {
    var picker = $(element).data("DateTimePicker");
    if (picker) {
      var koDate = ko.utils.unwrapObservable(valueAccessor());
      picker.date(koDate);
    }
  },
};

let currentContextMenu;

function hideCurrentContextMenu() {
  $("#contextMenu").css({
    display: "none",
  });
}

ko.utils.registerEventHandler(document, "click", function (event) {
  var button = event.which || event.button;
  if (!event.defaultPrevented && button < 2) {
    hideCurrentContextMenu();
  }
});
ko.bindingHandlers.contextMenu = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).on("contextmenu", (e) => {
      let top = e.screenY + $("#page").scrollTop() - 300;
      $("#contextMenu").css({
        display: "block",
        left: e.clientX,
        top: top,
      });
      e.target.style.position = "relative";
      $("#contextMenu a").attr("href", ko.unwrap(valueAccessor));

      return false;
    });
  },
};

ko.bindingHandlers.split = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var savedsizes = localStorage.getItem("split-sizes");
    let sizes: Array<number>;
    if (savedsizes) {
      sizes = JSON.parse(savedsizes);
    } else {
      sizes = [50, 50];
    }
    let splitElements = [];

    valueAccessor().panels.forEach((splitEl) => {
      let el = $(element).find(splitEl);
      splitElements.push(el[0]);
      el.addClass("split");
    });
    let split = Split(splitElements, {
      sizes: sizes,
      onDragEnd: function () {
        let sizes = JSON.stringify(split.getSizes());
        system.signals[Signal.splitSizesChanged].dispatch(sizes);
        localStorage.setItem("split-sizes", sizes);
      },
      direction: "vertical",
    });
    system.signals[Signal.splitSizesChanged].add((sizes) => {
      let currentsizes = JSON.stringify(split.getSizes());
      if (currentsizes != sizes) {
        split.setSizes(JSON.parse(sizes));
      }
    });
  },
};
ko.bindingHandlers.showModal = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    $(element).modal({
      show: false,
      backdrop: "static",
    });
  },

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext: any) {
    if (valueAccessor()()) {
      $(element).modal("show");
    } else {
      bindingContext.show = false;
      $(element).modal("hide");
    }
  },
};
ko.bindingHandlers.lookupDescription = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {},

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext: any) {
    var params = valueAccessor();
    var lookup = ko.unwrap(params.lookup);
    var name = ko.unwrap(params.name);
    var value = ko.unwrap(params.value);
    $(element).text(lookup(name, value) || value);
  },
};

ko.bindingHandlers["prop"] = {
  update: function (element, valueAccessor, allBindingsAccessor) {
    var value = ko.utils.unwrapObservable(valueAccessor()) || {};
    for (var propName in value) {
      if (typeof propName == "string") {
        var propValue = ko.utils.unwrapObservable(value[propName]);

        element[propName] = propValue;
      }
    }
  },
};

ko.bindingHandlers.expandExtended = {
  init: (t, e, n, o, r) => {},
  update: function (element, valueAccessor, n, o, r) {
    setTimeout(() => {
      const data: { content: string; isCollapsed: KnockoutObservable<boolean> } = valueAccessor();
      var hrefId = ko.unwrap(data.content);

      if ($(hrefId).outerHeight() > 60) {
        ($(hrefId).addClass("collapsed"),
          data.isCollapsed.subscribe(function (e) {
            (console.log(e),
              e
                ? ($(hrefId).removeClass("expanded"), $(hrefId).addClass("collapsed"), $(element).text("Expand"))
                : ($(hrefId).removeClass("collapsed"), $(hrefId).addClass("expanded"), $(element).text("Collapse")));
          }),
          $(element).click(function () {
            return (data.isCollapsed(!data.isCollapsed()), !1);
          }));
      } else $(element).hide();
    }, 100);
  },
};

ko.bindingHandlers.numericText = {
  update: function (element, valueAccessor, allBindingsAccessor) {
    const value = ko.utils.unwrapObservable(valueAccessor());
    const precision =
      ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.numericText.defaultPrecision;

    const formattedValue = value?.toFixed(precision);
    $(element).text(formattedValue);
  },
  defaultPrecision: 1,
};

ko.bindingHandlers.fileUpload = {
  init: function (element, valueAccessor) {
    ko.utils.registerEventHandler(element, "change", function () {
      var reader = new FileReader();

      reader.onload = function (e) {
        var value = valueAccessor();
        value(e.target.result);
      };

      reader.readAsDataURL(element.files[0]);
    });
  },
};

ko.bindingHandlers.timer = {
  update: function (element, valueAccessor) {
    const value = ko.utils.unwrapObservable(valueAccessor());
    let time: number = parseInt(value);

    var timer = setInterval(function () {
      time--;
      const minutes = Math.floor(time / 60);
      const seconds = time - minutes * 60;

      let result = "";
      if (minutes > 0) {
        result += `${minutes}`.padStart(2) + " min";
      }

      if (seconds > 0) {
        result += ` ${seconds}`.padStart(2) + " sec";
      }

      $(element).text(result);
      if (time <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  },
};

//#region Custom Function Callers

ko.bindingHandlers.functionCaller = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {},

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext: any) {
    const params = valueAccessor();
    const caller = ko.unwrap(params.caller);
    const body = ko.toJS(params);
    delete body.caller;
    const functionParams = Object.entries(body).map(([k, v]) => v);
    $(element).text(caller(...functionParams));
    $(element).attr("title", caller(...functionParams));
  },
};

ko.bindingHandlers.functionCallerHTML = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {},

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext: any) {
    const params = valueAccessor();
    const caller = ko.unwrap(params.caller);
    const body = ko.toJS(params);
    delete body.caller;
    const functionParams = Object.entries(body).map(([k, v]) => v);

    try {
      $(element).html(caller(...functionParams));
    } catch (err) {
      // ignore
    }
  },
};

ko.bindingHandlers.functionCallerApplyStyle = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {},

  update: function (element, valueAccessor, allBindings, viewModel, bindingContext: any) {
    const params = valueAccessor();
    const caller = ko.unwrap(params.caller);
    const body = ko.toJS(params);
    delete body.caller;
    const functionParams = Object.entries(body).map(([k, v]) => v);

    $(element).css(caller(...functionParams));
  },
};

ko.bindingHandlers.functionCallerClick = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    const params = valueAccessor();
    const caller = ko.unwrap(params.caller);

    const functionParams = params.value;

    // attach click event
    $(element).on("click", function (event) {
      caller(...functionParams, event);
    });

    // Clean up when element is removed
    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      $(element).off("click");
    });
  },
};

ko.bindingHandlers.functionCallerDisabled = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    const params = valueAccessor();
    const caller = ko.unwrap(params.caller);

    if (caller) {
      const functionParams = params.value;

      // Call the function and get the disabled state (true or false)
      const isDisabled = caller(...functionParams);

      // Set the element's disabled property based on the return value
      $(element).prop("disabled", isDisabled);

      // If the element is disabled, prevent click events entirely
      if (isDisabled) {
        $(element).on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
        });
      }

      // Clean up when the element is removed
      ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
        $(element).off("click"); // Remove the click event listener
      });
    }
  },
};

//#endregion

ko.bindingHandlers.popover = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    let place: any = "auto right";
    if (
      valueAccessor instanceof Function &&
      valueAccessor() instanceof Function &&
      bindingContext &&
      bindingContext.$data &&
      bindingContext.$data.verified_error_text
    ) {
      if (valueAccessor()() == bindingContext.$data.verified_error_text()) {
        place = "left";
      }
    } else if (
      valueAccessor instanceof Function &&
      bindingContext &&
      bindingContext.$data &&
      bindingContext.$data.error
    ) {
      place = "auto right";
    }
    $(element).popover({
      trigger: "hover",
      content: valueAccessor(),
      placement: place,
    });
  },
};
